import React, { Component } from "react";
import { Row, Col } from "antd";
import { render } from "react-dom";
import Styled from "styled-components";

const Container = Styled.div`
  .component {
    width:${props => props.componentValue}%;
    background-color:#338E4D;
  }
  .nonComponent {
    width:${props => props.nonComponentValue}%;
  }
`;

class ReportStatusChart extends Component  {
  render() {
    
    let nonComp = (100 - this.props.percentage);
    let compFormat = ((this.props.percentage % 1) > 0)?this.props.percentage.toFixed(2):this.props.percentage.toFixed(0);
    let nonCompFormat = ((nonComp % 1) > 0)?nonComp.toFixed(2):nonComp.toFixed(0);
    
    //old- 10% threshold as it is the min to support 4digits with decimal and % mark
    //New - Highest percentage will show the decimals. Low percentage will not show the decimals
    return (
      <Container componentValue={compFormat}  nonComponentValue={nonCompFormat}>
        <Row>
          <div className="stackedBar">
              {(compFormat > 0)? (
                <div className="component" value={compFormat}>
                  {(this.props.percentage >= nonComp)?(<span>{compFormat}%</span>):""}
                  {/* {(compFormat > 10)?(<span>{compFormat}%</span>):""} */}
                </div>
              ):("")}
              
              {(nonCompFormat > 0)? (
                <div className="nonComponent" value={nonCompFormat}>
                  {(nonComp > this.props.percentage)?(<span>{nonCompFormat}%</span>):""}
                  {/* {(nonCompFormat > 10)?(<span>{nonCompFormat}%</span>):""} */}
                </div>
              ):("")}
              
          </div>
        </Row>
      </Container>
    );
  }
}

export default ReportStatusChart;